var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"qrcode",style:(_vm.styles)},[_c('div',{staticClass:"image"},[_c('square',{attrs:{"src":_vm.qrImage}},[_vm._t("default")],2)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }